import React from "react";
import Header from "components/header/header";
import NavHeader from "components/Nav/navHeader";
import "./App.scss";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import Body from "components/body/body";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import WelcomePopUp from "components/Cards/WelcomePopUp";
import ContrastToggle from "components/controls/ContrastToggle/ContrastToggle";

const queryClient = new QueryClient();

const App: React.FC = () => {

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <div className="App">
          <ContrastToggle />
          <Header />
          <NavHeader />
          <WelcomePopUp />
          <Body />
        </div>
      </Provider>
    </QueryClientProvider>
  );
};

export default App;
